import { extractByTypename } from '@local/utils'

import { gql } from '@web/gql'
import { Menu, MenuOption, ProofType, GetHotelProof_VisitFragment, HotelProof } from '@web/gql/graphql'
import { PROOF_LABEL_MAP } from '@web/libs/constants'
import { DeepNonNullable, Nullish } from '@web/types'

/**
 * 메뉴 가격, 수량, 총 금액이 falsy 일때 노출할 레이블
 */
const EMPTY_LABEL_IN_MENU = '-'

export const convertMenuLabel = (menu: Partial<Menu> | Partial<MenuOption>, isReservationProof = false) => {
  if (isReservationProof) {
    return { name: menu.name }
  }

  return {
    name: menu.name,
    unitPrice: menu.unitPrice ? menu.unitPrice.toLocaleString() : EMPTY_LABEL_IN_MENU,
    quantity: menu.quantity || EMPTY_LABEL_IN_MENU,
    totalPrice: menu.totalPrice ? `${menu.totalPrice?.toLocaleString()}원` : EMPTY_LABEL_IN_MENU,
  }
}

export const displayProofName = (proofType: ProofType): string | null => {
  return PROOF_LABEL_MAP.review[proofType] ?? null
}

export const getHotelProof = (visit: GetHotelProof_VisitFragment) => {
  const { HotelProof } = extractByTypename(visit.private?.proofs?.find(proof => proof.type === ProofType.Hotel))
  return HotelProof
}

getHotelProof.fragment = gql(`
  fragment GetHotelProof_Visit on Visit {
    private {
      proofs {
        type
        totalPriceText {
          korean
        }
        ...on HotelProof {
          checkInDate
          checkOutDate
        }
      }
    }
  }
`)

export const hasCheckInOutDate = (
  proof: Nullish<Pick<HotelProof, 'type' | 'checkInDate' | 'checkOutDate'>>,
): proof is DeepNonNullable<Pick<HotelProof, 'type' | 'checkInDate' | 'checkOutDate'>> => {
  return !!proof && !!proof.checkInDate && !!proof.checkOutDate
}
